<template>
  <div class="group">
    <hr
      class="border-t border-gray-700 transition group-first:hidden dark:border-border"
      :class="[!context.isMobile ? `-mx-2 my-2` : `-mx-3 my-3`]"
    />

    <span
      class="my-1 block shrink-0 select-none px-3 text-[0.8125rem] leading-5 text-gray-400 transition group-first:mt-0 dark:border-border dark:text-muted-foreground"
    >
      <slot></slot>
    </span>
  </div>
</template>

<script lang="ts" setup>
import { inject } from "./context";

const context = inject();
</script>
